// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"a4684cd5","665":"93d71358","872":"4ad49491"}[chunkId] + ".chunk.css";
};